import React, { useState } from 'react'
import { useCompany, useUser } from 'models';
import CardItem from './CardItem';
import Can from 'components/Can';
import { Col, Form, Row } from 'react-bootstrap';

import * as rebateColor from 'images/rebate-color.png'
import * as statementColor from 'images/statement-color.png'
import * as reportsColor from 'images/reports-color.png'

export default function () {
  const user = useUser()
  const { company } = useCompany();

  const items = [
    {
      permission: 'scancash.list',
      path: '/elite/scansource-select',
      icon: rebateColor,
      title: 'Fundos ScanSource Select'
    },
    {
      permission: 'scancash.statement',
      path: '/elite/scansource-select/statement',
      icon: statementColor,
      title: 'Extrato ScanSource Select'
    }
  ]

  if (user.profile.profile_type_id != 1) {
    items.push({
      permission: 'report.index',
      path: '/elite/reports',
      icon: reportsColor,
      title: 'Relatórios'
    })
  }

  return (<>
    <Col sm="12" md="12" lg="12">
      <Row>
        <Col xs="auto">
          <h6>ScanSource Select</h6>
        </Col>
      </Row>
    </Col>
    <Row>
      {items.map((item, idx) => {
        return (
          <Can do={item.permission} on="App" key={idx}>
            <CardItem item={item} className={item.old ? "card-old" : ""}/>
          </Can>
        )
      })}
    </Row>
  </>)
}